module.exports = {"id":"221422","name":"Sverrir Ingi Ingason","rating":"73","photo":"./data/images/photos/0/221422.png","club":{"name":"FK Rostov","logo":"./data/images/clubs/FKRostov.png"},"positions":["DC","DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SverrirIngiIngason0.json
// module id = 4061
// module chunks = 0